import { useMutation } from "@tanstack/react-query";
import { authService } from "../authService";
import type { RequestOtpType } from "../authType";

/**
 * Solicita o envio de um código OTP por WhatsApp. Usado tanto na tela inicial
 * de "Entrar com WhatsApp" quanto no botão "Reenviar código".
 */
export const useRequestOtp = () => {
  const { mutate: requestOtp, isPending: isRequestingOtp } = useMutation<
    void,
    Error,
    RequestOtpType
  >({
    mutationFn: ({ cellPhone }) => authService.handleRequestOtp(cellPhone),
  });

  return {
    requestOtp,
    isRequestingOtp,
  };
};
